// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/text_mask.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum social.chat.entity.v2.TextFormat
 */
export const TextFormat = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.TextFormat",
  [
    {no: 0, name: "TEXT_FORMAT_REGULAR", localName: "REGULAR"},
    {no: 1, name: "TEXT_FORMAT_BOLD", localName: "BOLD"},
    {no: 2, name: "TEXT_FORMAT_ITALIC", localName: "ITALIC"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MaskedText
 */
export const MaskedText = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MaskedText",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TextMaskValue} },
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextMaskValue
 */
export const TextMaskValue = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.TextMaskValue",
  () => [
    { no: 1, name: "format", kind: "enum", T: proto3.getEnumType(TextFormat) },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "link", kind: "message", T: TextLink },
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextLink
 */
export const TextLink = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.TextLink",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(TextLink_LinkType) },
    { no: 2, name: "ref", kind: "message", T: TextLink_LinkRef },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.TextLink.LinkType
 */
export const TextLink_LinkType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.TextLink.LinkType",
  [
    {no: 0, name: "LINK_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINK_TYPE_USER", localName: "USER"},
    {no: 2, name: "LINK_TYPE_SYMBOL", localName: "SYMBOL"},
    {no: 3, name: "LINK_TYPE_KNOWN_URL", localName: "KNOWN_URL"},
    {no: 4, name: "LINK_TYPE_URL", localName: "URL"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextLink.LinkRef
 */
export const TextLink_LinkRef = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.TextLink.LinkRef",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
  ],
  {localName: "TextLink_LinkRef"},
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMaskedText
 */
export const PlaceholderMaskedText = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.PlaceholderMaskedText",
  () => [
    { no: 1, name: "masked_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: PlaceholderMask} },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMask
 */
export const PlaceholderMask = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.PlaceholderMask",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PlaceholderMask_PlaceholderType) },
    { no: 2, name: "placeholder", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reference", kind: "message", T: PlaceholderMask_Reference },
  ],
);

/**
 * used to determine "username" and "to be" based on the user's point of view
 * First person point of view example: "You are an admin now"
 * Third person point of view example: "StockbitUser is an admin now"
 *
 * @generated from enum social.chat.entity.v2.PlaceholderMask.PlaceholderType
 */
export const PlaceholderMask_PlaceholderType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.PlaceholderMask.PlaceholderType",
  [
    {no: 0, name: "PLACEHOLDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLACEHOLDER_TYPE_USERNAME", localName: "USERNAME"},
    {no: 2, name: "PLACEHOLDER_TYPE_TO_BE", localName: "TO_BE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMask.Reference
 */
export const PlaceholderMask_Reference = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.PlaceholderMask.Reference",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "PlaceholderMask_Reference"},
);

